import { LuLayoutDashboard } from 'react-icons/lu'
import { FaTruck, FaUsersCog, FaUserSecret } from 'react-icons/fa'
import { HiOutlineBuildingStorefront } from 'react-icons/hi2'
import { GiGreenhouse } from 'react-icons/gi'
import { AiFillProject } from 'react-icons/ai'
import { GrContact, GrDriveCage, GrStorage } from 'react-icons/gr'
import { VscGroupByRefType, VscServerProcess } from 'react-icons/vsc'
import { MdOutlineFileUpload, MdOutlineMailOutline, MdTrolley } from 'react-icons/md'
import { IoCloudUploadOutline } from 'react-icons/io5'
import { TbReport } from 'react-icons/tb'
import { BiSolidShoppingBags } from 'react-icons/bi'
import { FaTruckFast } from 'react-icons/fa6'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                url: '/admin',
                text: 'Dashboard',
                icon: <LuLayoutDashboard />,
            },
            {
                active: ['/admin/admins'],
                url: '/admin/admins',
                text: 'Admins',
                icon: <FaUserSecret />,
            },
            {
                active: ['/admin/collection-points', '/admin/collection-point-bag-requests'],
                url: '/admin/collection-points',
                text: 'Collection Points',
                icon: <HiOutlineBuildingStorefront />,
                child: [
                    {
                        url: '/admin/collection-points',
                        text: 'Collection Points',
                    },
                    {
                        active: ['/admin/collection-point-bag-requests'],
                        url: '/admin/collection-point-bag-requests',
                        text: 'Request Bags',
                    },
                ],
            },
            {
                active: ['/admin/member-products'],
                url: '/admin/member-products',
                text: 'Member Products',
                icon: <IoCloudUploadOutline />,
            },
            {
                active: ['/admin/affiliates'],
                url: '/admin/affiliates',
                text: 'Recyclers',
                icon: <GiGreenhouse />,
            },
            {
                active: ['/admin/storages'],
                url: '/admin/storages',
                text: 'Storage',
                icon: <GrStorage />,
            },
            {
                active: ['/admin/users'],
                url: '/admin/users',
                text: 'Users',
                icon: <FaUsersCog />,
                child: [
                    {
                        url: '/admin/users',
                        text: 'Users',
                    },
                    {
                        url: '/admin/users/create',
                        text: 'Add new',
                    },
                ],
            },
            {
                active: ['/admin/projects'],
                url: '/admin/projects',
                text: 'Projects',
                icon: <AiFillProject />,
            },
            {
                active: ['/admin/bin-box'],
                url: '/admin/bin-box',
                text: 'Bin Box',
                icon: <GrDriveCage />,
            },
            {
                active: ['/admin/bin-bags'],
                url: '/admin/bin-bags',
                text: 'Bin Bags',
                icon: <BiSolidShoppingBags />,
            },
            {
                active: ['/admin/project-bag-drops'],
                url: '/admin/project-bag-drops',
                text: 'Project Bag Drops',
                icon: <FaTruckFast />,
            },
            {
                active: ['/admin/pickups'],
                url: '/admin/pickups',
                text: 'Pickups',
                icon: <FaTruck />,
            },
            {
                active: ['/admin/dispatches'],
                url: '/admin/dispatches',
                text: 'Dispatches',
                icon: <MdTrolley />,
            },
            {
                active: ['/admin/affiliate-rejected-materials'],
                url: '/admin/affiliate-rejected-materials',
                text: 'Recycling Efficiency',
                icon: <VscServerProcess />,
            },
            {
                active: ['/admin/materials', '/admin/batch-reject-types', '/admin/settings'],
                text: 'Settings',
                icon: <VscGroupByRefType />,
                child: [
                    {
                        active: ['/admin/materials'],
                        url: '/admin/materials',
                        text: 'Materials',
                    },
                    {
                        active: ['/admin/batch-reject-types'],
                        url: '/admin/batch-reject-types',
                        text: 'Batch Reject Categories',
                    },
                    {
                        active: ['/admin/settings'],
                        url: '/admin/settings',
                        text: 'Dynamic Link',
                    },
                ],
            },
            {
                active: ['/admin/send-mail'],
                url: '/admin/send-mail',
                text: 'Send Email',
                icon: <MdOutlineMailOutline />,
            },
            {
                active: ['/admin/announcements'],
                url: '/admin/announcements',
                text: 'Announcements',
                icon: <MdOutlineMailOutline />,
            },
            {
                active: ['/admin/file-uploads'],
                // url: '/admin/file-uploads',
                url: 'https://www.resiloop.org.au/collectors-resource-hub.html',
                text: 'Resources',
                icon: <MdOutlineFileUpload />,
            },
            {
                active: ['/admin/contacts'],
                url: '/admin/contacts',
                text: 'Messages',
                icon: <GrContact />,
            },

            {
                active: ['/admin/report'],
                text: 'Report',
                icon: <TbReport />,
                child: [
                    {
                        active: ['/admin/report/collection-point-bag-distribution'],
                        url: '/admin/report/collection-point-bag-distribution',
                        text: 'Collection Point Bag Distribution',
                    },
                    {
                        active: ['/admin/report/project'],
                        url: '/admin/report/project',
                        text: 'Project',
                    },
                ],
            },
        ],
    },
]

export default appRoutes
